<template>
  <div v-if="isLoaded" class="export_images_v2">
    <div v-if="isShowTabs" class="eiv2_tabs_header">
      <bxs-tab v-model="activeIndex" @change="slideSwiperToIndex">
        <bxs-tab-item v-for="o in exportImagesOptions" :key="o.key">
          <div v-html="o.html" />
        </bxs-tab-item>
      </bxs-tab>
    </div>
    <div class="eiv2_content">
      <div class="main">
        <bxs-swiper
          ref="Swiper"
          :autoplay="false"
          :loop="false"
          :pagination="false"
          @slide="activeIndex = $event"
        >
          <bxs-swiper-item v-for="o in exportImagesOptions" :key="o.key">
            <Component
              :is="o.key"
              :ref="o.key"
              :scene="scene"
              :result-data="resultData"
              :vertical="o.key === 'verticalTable'"
              :liability-show-type="_liabilityShowType"
              :is-show-business-card="isShowBusinessCard"
              :card-image-data="allCardImageData[o.key] || allCardImageData.common"
              :theme-settings="themeSettings"
              @previewAllImages="previewAllImages"
            />
          </bxs-swiper-item>
        </bxs-swiper>
      </div>
      <div v-if="isShowActionButtons" class="footer">
        <div v-if="currentImage.key !== 'longPic'" class="qrcode">
          <bxs-checkbox v-model="isShowBusinessCard">
            图片包含名片和二维码，客户可扫码进入计划书
          </bxs-checkbox>
        </div>
        <div class="actions">
          <div
            v-if="currentImage.key === 'longPic'"
            class="eis_preivew"
            @click="captureWebContent"
          >
            <span>预览</span>
          </div>
          <ShareActions
            v-else
            :current-image="currentImage"
            @handle="onClickShareAction"
          />
        </div>
        <div v-if="isShowCancelButton" class="cancal" @click="$emit('cancel')">
          取消
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import QS from 'qs'
import { get as _get, cloneDeep } from 'lodash'
import { Tab, TabItem, Swiper, SwiperItem, Checkbox, Toast } from 'bxs-ui-vue';
import { URL_PARAM } from '@/utils/variables.js'
import { getImagesOptions } from './constant'
import { drawCardImage, showImageViewer } from './handler'

import interestTable from './components/interest_table/index.vue'
import horizontalTable from './components/normal_table/index.vue'
import verticalTable from './components/normal_table/index.vue'
import mindMapping from './components/mind_mapping/index.vue'
import indentTree from './components/indent_tree_g6/index.vue'
import normalTree from './components/normal_tree_g6/index.vue'
import longPic from './components/long_pic/index.vue'
import ShareActions from './components/actions/index.vue'

Vue.use(Toast)
export default {
  components: {
    [Tab.name]: Tab,
    [TabItem.name]: TabItem,
    [Swiper.name]: Swiper,
    [SwiperItem.name]: SwiperItem,
    [Checkbox.name]: Checkbox,
    interestTable,
    horizontalTable,
    verticalTable,
    mindMapping,
    indentTree,
    normalTree,
    longPic,
    ShareActions
  },
  props: {
    scene: {
      type: Number,
      default () {
        // 1-通用计划书结果页（commonPkResult）
        // 2-通用家庭计划书结果页（familyPkResult）
        // 3-计划书结果页（弹层）
        // 4-家庭计划书结果页（弹层）
        // 5-计划书结果页（PC版）
        // 6-家庭计划书结果页（PC版）
        return 3
      }
    },
    liabilityShowType: {
      type: Number,
      default: 0
    },
    plainResultData: Object,
    themeSettings: {
      type: Object,
      default: () => ({})
    },
    isShowInterestTable: Boolean
  },
  data () {
    return {
      isLoaded: false,
      resultData: cloneDeep(this.plainResultData) || null,
      activeIndex: 0,
      allCardImageData: {},
      isShowBusinessCard: true,
      actionChannel: null
    }
  },
  computed: {
    themeKey () {
      return _get(this, 'themeSettings.previewTheme') || ''
    },
    _liabilityShowType () {
      return Number(URL_PARAM.liabilityShowType || this.liabilityShowType) || 0
    },
    isShowTabs () {
      return ![5, 6].includes(this.scene)
    },
    isShowActionButtons () {
      return this.currentImage && ![5, 6].includes(this.scene)
    },
    isShowCancelButton () {
      return [3, 4].includes(this.scene)
    },
    exportImagesOptions () {
      const options = getImagesOptions(this.scene, {
        isShowInterestTable: this.isShowInterestTable
      })
      if ([5, 6].includes(this.scene)) {
        return options.filter(ele => ele.key === (URL_PARAM.chartName || 'horizontalTable'))
      }
      return options
    },
    currentImage () {
      const index = this.activeIndex < 0 ? 0 : this.activeIndex
      return this.exportImagesOptions[index]
    },
    imagesOptionsCanRenderByWeb () {
      return this.exportImagesOptions.filter(o => o.key !== 'longPic')
    },
    shareToPrintInfo () {
      const { scene, _liabilityShowType, resultData, currentImage, themeKey : theme } = this
      const { uuid, coverId, familyId } = URL_PARAM
      const name = _get(resultData, 'card.name') || ''
      const cardUuid = _get(resultData, 'card.uuid') || ''
      let title = `${name}为您定制的保险计划书`
      let content = '专属保障计划请查阅！保险—让生活更美好'
      let imgUrl = _get(resultData, 'insuranceType.wechatSharedLogoUrl') || ''
      if ([2, 4].includes(scene)) {
        const firstMemberName = _get(resultData, 'members[0].name') || ''
        const firstMemberSex = _get(resultData, 'members[0].sex')
        const preTitle = firstMemberName ? `${firstMemberName}${firstMemberSex == 1 ? '先生' : '女士'}的` : ''
        title = `${preTitle}家庭保障计划`
        content = '请查收您的专属家庭保障计划，保险让生活更美好'
        imgUrl = 'https://img.winbaoxian.com/autoUpload/planbook/1561594277637_.pic_hd_7feb9fe70ec74de.jpg'
      }
      const urlParams = {
        chartName: _get(currentImage, 'key') || '',
        uuid,
        coverId,
        theme,
        familyId,
        cardUuid,
        liabilityShowType: _liabilityShowType
      }
      return  {
        title,
        content,
        imgUrl,
        shareUrl: `${location.origin}${location.pathname}`.replace(/pages\/.*\.html/, 'pages/planbkChartInPcv2.html') + `?${QS.stringify(urlParams)}`,
        shareChannel: ['wechat_friends']
      }
    }
  },
  watch: {
    themeKey () {
      this.drawAllCardImages()
    }
  },
  async created () {
    await this.drawAllCardImages()
    this.isLoaded = !!this.resultData && !!this.currentImage
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    async init () {
      this.activeIndex = Math.max(this.exportImagesOptions.findIndex(o => o.key === URL_PARAM.chartName), 0)
      this.slideSwiperToIndex(this.activeIndex)
    },
    slideSwiperToIndex (index) {
      const swiperRef = this.$refs.Swiper
      if (swiperRef) {
        swiperRef.slideToIndex(index)
      }
    },
    async drawAllImages () {
      const allImagesData = {}
      appBridge.showLoading()
      for (const option of this.imagesOptionsCanRenderByWeb) {
        const _currentImage = await this.getCurrentImage(option.key, false)
        if (_currentImage.dataUrl) {
          allImagesData[option.key] = _currentImage.dataUrl
        }
      }
      appBridge.hideLoading()
      return allImagesData
    },
    async drawAllCardImages () {
      const self = this
      const { scene, resultData, exportImagesOptions, themeKey : theme } = self
      const userInfo = _get(resultData, 'card') || {}
      const { uuid, coverId } = URL_PARAM
      const { uuid : cardUuid, photo, name, telephone } = userInfo
      const cardInfo = {
        nw: 1,
        uuid,
        theme,
        coverId,
        cardUuid,
        photo,
        name,
        telephone
      }
      this.allCardImageData = {}
      const allCardImageData = {}
      allCardImageData.common = await drawCardImage(cardInfo, {
        scene
      })
      const mindMappingOption = exportImagesOptions.find(e => e.key === 'mindMapping')
      if (mindMappingOption) {
        allCardImageData.mindMapping = await drawCardImage(cardInfo, {
          scene,
          width: 375,
          fontSize: 12
        })
      }
      this.allCardImageData = allCardImageData
    },
    async onClickShareAction (key) {
      const self = this
      const _currentImageKey = _get(self, 'currentImage.key')
      const _ref = _get(self, `$refs[${_currentImageKey}][0]`)
      if (!_ref) {
        self.$toast(`加载失败：${_currentImageKey}`)
        return
      }
      switch (key) {
        case 'theme': {
          self.$emit('openThemePicker')
          break;
        }
        case 'setting': {
          self.$emit('openInterestSettingPopup')
          break;
        }
        default: {
          const _currentImage = await self.getCurrentImage(null, true)
          if (_currentImage.dataUrl) {
            self.shareImage(key, _currentImage.dataUrl)
          }
        }
      }
      window.WeiyiStatSDK.submit(key, {
        type: _currentImageKey
      })
    },
    async shareImage (shareChannel, imgData) {
      const { shareToPrintInfo } = this
      switch(shareChannel) {
        case 'wechat_timeline':
        case 'wechat_friends':
        case 'qq_friends': {
          if (appBridge.checkAppFeature('SHARE_POSTER_IMAGE')) {
            appBridge.sharePosterImage({
              imageType: 1,
              imgUrl: '',
              imageData: imgData,
              shareChannel: [shareChannel]
            })
          }
          break
        }
        case 'download': {
          if (appBridge.checkAppFeature('SAVE_POSTER_IMAGE')) {
            appBridge.savePosterImage({
              type: 1,
              imgUrl: '',
              imageData: imgData
            })
          }
          break
        }
        case 'print': {
          if (appBridge && appBridge.checkAppFeature('APP_SHARE')) {
            appBridge.share(shareToPrintInfo)
          }
          break
        }
      }
    },
    captureWebContent () {
      if (!appBridge || !appBridge.checkAppFeature('CAPTURE_WEB_CONTENT')) {
        return
      }
      this.$emit('screen-capture', async () => {
        try {
          const res = await appBridge.captureWebContent()
          return Promise.resolve(res.status)
        } catch (err) {
          return Promise.reject(err)
        }
      })
      this.$emit('cancel')
    },
    async previewAllImages () {
      const self = this
      const { scene, activeIndex, currentImage, shareToPrintInfo, imagesOptionsCanRenderByWeb } = self
      if ([5, 6].includes(scene)) {
        return
      }
      const _currentImageKey = _get(currentImage, 'key')
      const hasPreviewImagesToShare = appBridge && appBridge.checkAppFeature('PREVIEW_IMAGES_TO_SHARE')
      if (hasPreviewImagesToShare) {
        const allImagesData = await self.drawAllImages()
        const imageInfos = imagesOptionsCanRenderByWeb
          .filter(item => allImagesData[item.key])
          .map(item => ({
            imageData: allImagesData[item.key],
            shareItemInfo: item.key === 'interestTable' ? null : shareToPrintInfo
          }))
        if (imageInfos.length) {
          const index = allImagesData[_currentImageKey] ? activeIndex : 0
          appBridge.previewImagesToShare(imageInfos, index)
        } else {
          this.$toast('没有生成图片')
        }
        console.log('PREVIEW_IMAGES_TO_SHARE')
      } else {
        const _currentImage = await self.getCurrentImage(null, true)
        if (_currentImage.dataUrl) {
          showImageViewer(_currentImage.dataUrl)
        } else {
          this.$toast('没有生成图片')
        }
        console.log('showImageViewer')
      }
    },
    async getCurrentImage (key, isShowLoading = true) {
      const _currentImage = key ? {
        key
      } : cloneDeep(this.currentImage) || {}
      const _key = _get(_currentImage, 'key')
      const _generateImage = _get(this, `$refs[${_key}][0].generateImage`)
      let dataUrl = null
      if (_generateImage) {
        dataUrl = await _generateImage(isShowLoading)
      }
      _currentImage.dataUrl = dataUrl
      return _currentImage
    }
  }
}
</script>
<style>
  @import './index.css';
</style>